import { Component, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { OptionSelectionComponent } from './components/option-selection/option-selection.component';
import { CommonModule } from '@angular/common';
import { MainTextComponent } from './components/main-text/main-text.component';
import { CookieService } from 'ngx-cookie-service';
import { CookiePreferencesService } from 'src/app/core/services/cookie-preferences.service';

@Component({
  selector: 'aig-cookies',
  imports: [
    CommonModule,
    ModalComponent,
    OptionSelectionComponent,
    MainTextComponent,
  ],
  templateUrl: './cookies.component.html',
  styleUrl: './cookies.component.scss',
})
export class CookiesComponent {
  mainText: boolean = false;
  optionSelection: boolean = false;

  config: boolean = true;
  savePref: boolean = false;

  constructor(private cookiePreferencesService: CookiePreferencesService) {}

  ngOnInit() {
    this.mainText = true;
  }

  configCookies() {
    this.optionSelection = true;
    this.config = false;
    this.savePref = true;
  }

  @Output() closeCookies = new EventEmitter<boolean>();

  aceptAllCookies() {
    this.cookiePreferencesService.savePreferences({
      functional: true,
      marketing: true,
      analytics: true,
    });
    this.closeCookies.emit(false);
  }

  aceptFunctionalCookies() {
    this.cookiePreferencesService.savePreferences({
      functional: true,
      marketing: false,
      analytics: false,
    });
    this.closeCookies.emit(false);
  }

  savePreferencies() {
    this.closeCookies.emit(false);
  }
}
